import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingWrapper = _resolveComponent("LoadingWrapper")!
  const _component_Name = _resolveComponent("Name")!
  const _component_Duration = _resolveComponent("Duration")!
  const _component_DeliveryMode = _resolveComponent("DeliveryMode")!
  const _component_BudgetWrapper = _resolveComponent("BudgetWrapper")!
  const _component_CampaignSettingsCheckboxes = _resolveComponent("CampaignSettingsCheckboxes")!
  const _component_PartnershipType = _resolveComponent("PartnershipType")!
  const _component_CampaignType = _resolveComponent("CampaignType")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_LoadingWrapper, {
      classes: [
			'CampaignEditorRow',
			'CampaignEditorSubtitle'
		],
      isLoading: _ctx.isLoading,
      tag: "h2"
    }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode(" Campaign Settings ", -1 /* CACHED */)
      ]))]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["isLoading"]),
    _createVNode(_component_Name),
    _createVNode(_component_Duration),
    _createVNode(_component_DeliveryMode),
    _createVNode(_component_BudgetWrapper),
    _createVNode(_component_CampaignSettingsCheckboxes),
    _createVNode(_component_PartnershipType),
    _createVNode(_component_CampaignType)
  ], 64 /* STABLE_FRAGMENT */))
}